module.exports = __webpack_public_path__ + "img/upgraded-calendar.584137a1.svg";